<template>
  <div class="wrapper">
    <div class="animated fadeIn">
        <div class="row">
            <div class="card-block col-md-12">
              <div class="row">
                 <div class='col-md-10'>
                  <a href="#" @click.prevent="showInformation()" class="information"><i class="icon-info"></i></a> <h1>{{distribuidor.Nombre}}</h1>
                </div>
                <div class="col-md-2">
                  <b-button @click="exportExcel()"variant="primary" size="sm" class="pull-right" >
                      <template v-if="excelLoading == false"><i class="fa fa-download"></i> Exportar historial</template>
                      <template v-else><loader :size="'small'" :color="'white'">Exportando</loader></template>
                  </b-button>
                </div>
              </div>
            </div>
              <div class="col-md-4">
                  <b-card no-block>
                    <div class="card-body p-2 clearfix no-padding">
                      <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                      <div class="h5 text-primary mb-0 mt-2">{{distribuidor.Comprados | quantity}}</div>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Comprados</div>
                    </div>
                  </b-card>
              </div>
              <div class="col-md-4">
                  <b-card no-block>
                    <div class="card-body p-2 clearfix">
                      <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                      <div class="h5 text-primary mb-0 mt-2">{{distribuidor.Asignados | quantity}}</div>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Asignados</div>
                    </div>
                  </b-card>
              </div>
              <div class="col-md-4">
                  <b-card no-block>
                    <div class="card-body p-2 clearfix">
                      <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
                      <div class="h5 text-primary mb-0 mt-2">{{distribuidor.Disponibles | quantity}}</div>
                      <div class="text-muted text-uppercase font-weight-bold font-xs">Disponibles</div>
                    </div>
                  </b-card>
              </div>  
            <div class="col-md-7">
                <asignaciones :informacion="distribuidor.asignaciones" />
            </div>
            <div class="col-md-5">
                 <compras :informacion="distribuidor.compras" :status="distribuidor.Estatus" :Nombre="distribuidor.Nombre" />
            </div>
        </div>
    </div>
    <asignar></asignar>
    <information></information>
      <editar></editar>
  </div>
</template>
<script>
import moment from 'moment'
import Asignaciones from '@/views/Distribuidores/Historial/Asignaciones'
import Compras from '@/views/Distribuidores/Historial/Compras'
import editar from '@/views/Distribuidores/Historial/Editar'
import Asignar from '@/views/Distribuidores/Crud/Asignar'
import EventBus from '@/event-bus.js'
import Information from '@/views/Distribuidores/Information'
import Loader from '@/components/Loader'

export default {
  name: 'Distribuidor',
  components: {
    Asignaciones,
    Compras,
    Asignar,
    Information,
    Loader,
    editar
  },
  data () {
    return {
      excelLoading: false,
      distribuidor: {asignaciones: []},
      asignacion: {},
      draft: {
        Id: this.$route.params.id
      }
    }
  },
  filters: {
    quantity (quan) {
      return (typeof quan === 'undefined') ? quan : quan.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    fecha (asignacion) {
      let date = moment(asignacion).format('DD-MMM-YYYY')
      let res = date.split('-')
      res[1] = res[1].charAt(0).toUpperCase() + res[1].slice(1)
      return res.join('-')
    }
  },
  methods: {
    showInformation () {
      let information = Object.assign({}, this.distribuidor)
      delete information.Id
      delete information.asignaciones
      delete information.compras
      delete information.Correo_2
      delete information.Correo_3
      delete information.NotificarTotal
      delete information.Asignados
      delete information.Disponibles
      delete information.Comprados

      EventBus.$emit('openInformation', information)
    },
    exportExcel () {
      this.excelLoading = true
      let response = this.$store.dispatch('distribuidorExcel', this.draft)
      response.then(response => {
        this.excelLoading = false
        window.open(response.data.url)
      }).catch(errors => {
        this.$store.commit('authLogout', '')
        this.$router.push('/login')
      })
    },
    fetchDistribuidor () {
      let response = this.$store.dispatch('fetchDistribuidor', this.$route.params.id)
      response.then(response => {
        EventBus.$emit('breadcrumnaming', response.data.Nombre.charAt(0).toUpperCase() + response.data.Nombre.slice(1))
        this.distribuidor = response.data
      }).catch(errors => {
        this.$store.commit('authLogout', '')
        this.$router.push('/login')
      })
    }
  },
  mounted () {
    EventBus.$on('Asignacion', response => {
      this.fetchDistribuidor()
    })
    this.fetchDistribuidor()
  }
}
</script>
<style scoped>
    a.information {
      display: inline-block;
      position: relative;
      font-size: 20px;
      vertical-align: top;
      margin-top: 10px;
    }
    h1 {
      display: inline-block;
      position: relative;
    }
    .information-card {
      height: 319px;
    }
    .float-right-aligment {
      float: right;
    }
    .right-aligment {
        text-align: right;
    }
    .form-control-invalid {
      border-color: red;
    }
    .form-control-feedback {
      color: red;
    }
    .card-body {
      padding: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/views/Distribuidores/Distribuidor.vue